import { xpathParser, } from './xpathParser'

export const getCDF = (value, filters) => {
  if (!filters) return

  let cdf = filters.filter((filter) => filter.jsonPath && filter.jsonPath.includes(value))
  if (!cdf.length) return null

  if (cdf.length > 1) {
    if (cdf[0].jsonPath.includes('.other')) cdf = cdf.reverse()
    if (xpathParser(cdf[0].xpath) === xpathParser(cdf[1].xpath)) return xpathParser(cdf[0].xpath)
    return `${xpathParser(cdf[0].xpath)} & ${xpathParser(cdf[1].xpath)}`
  }

  return xpathParser(cdf[0].xpath)
}





// WEBPACK FOOTER //
// ./src/utils/cdf.js